import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/site/wwwroot/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/node_modules/next/font/google/target.css?{\"path\":\"src/providers/layout/fonts.js\",\"import\":\"Lato\",\"arguments\":[{\"weight\":[\"400\",\"300\",\"100\",\"900\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-lato\"}],\"variableName\":\"Lato\"}");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/node_modules/next/font/google/target.css?{\"path\":\"src/providers/layout/fonts.js\",\"import\":\"Vazirmatn\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"subsets\":[\"arabic\"],\"display\":\"swap\",\"variable\":\"--font-vazirmatn\"}],\"variableName\":\"Vazirmatn\"}");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/egypt-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/egypt-2.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/egypt.svg");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/iraq-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/iraq-2.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/iraq.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/ksa-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/ksa-2.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/ksa.webp");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/pakistan-1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/pakistan.webp");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/usAndCanada.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/public/medias/where-to-buy/usCanada1.png");
;
import(/* webpackMode: "eager" */ "/home/site/wwwroot/src/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/src/providers/layout/snackbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/src/providers/store/modalsStoreProvider.js");
